module.exports = __webpack_public_path__ + "assets/logout.4694967e.svg";